// extracted by mini-css-extract-plugin
export default {"tab":"ContractHeader_tab__ekBM6","activeTab":"ContractHeader_activeTab__S+bY7"};